function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import isPromise from 'is-promise';
import { setImmediate } from 'tiny-set-immediate';
import warning from 'tiny-warning';
var UNRESOLVED = {};

/**
 * Detects a resolved Promise by racing a sentinel value with the promise.
 * If the sentinel returns first the promise is still pending.
 *
 * If the value is not a promise it's simply returned
 */
export function checkResolved(value) {
  if (!isPromise(value)) {
    return value;
  }
  var ret = Promise.race([value, new Promise(function (resolve) {
    setImmediate(resolve, UNRESOLVED);
  })]);
  return ret;
}
export function isResolved(value) {
  return value !== UNRESOLVED;
}
function accumulateRouteValuesImpl(routeValues, routeIndices, callback, initialValue) {
  var accumulated = [];
  var value = initialValue;
  var _iterator = _createForOfIteratorHelper(routeIndices),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var routeIndex = _step.value;
      if (_typeof(routeIndex) === 'object') {
        // eslint-disable-next-line no-loop-func
        Object.values(routeIndex).forEach(function (groupRouteIndices) {
          accumulated.push.apply(accumulated, _toConsumableArray(accumulateRouteValuesImpl(routeValues, groupRouteIndices, callback, value)));
        });
      } else {
        value = callback(value, routeValues.shift());
        accumulated.push(value);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return accumulated;
}
export function accumulateRouteValues(routeValues, routeIndices,
// TODO: type this better
callback, initialValue) {
  return accumulateRouteValuesImpl(_toConsumableArray(routeValues), routeIndices, callback, initialValue);
}
export function getRouteMatches(match) {
  return match.routes.map(function (route, i) {
    return Object.assign({}, match, {
      route: route,
      routeParams: match.routeParams[i]
    });
  });
}
export function getRouteValue(match, getGetter, getValue) {
  var route = match.route;
  var getter = getGetter(route);
  return getter ? getter.call(route, match) : getValue(route);
}

// This is a little more versatile than if we only passed in keys.
export function getRouteValues(routeMatches, getGetter, getValue) {
  return routeMatches.map(function (match) {
    return getRouteValue(match, getGetter, getValue);
  });
}
function getRouteGetComponent(route) {
  return route.getComponent;
}
function getRouteComponent(route) {
  if (process.env.NODE_ENV !== "production" && route.component) {
    process.env.NODE_ENV !== "production" ? warning(route.Component, "Route with `component` property `".concat(route.component.displayName || route.component.name, "` has no `Component` property. The expected property for the route component is `Component`.")) : void 0;
  }
  return route.Component;
}

// This should be common to most resolvers, so make it available here.
export function getComponents(routeMatches) {
  return getRouteValues(routeMatches, getRouteGetComponent, getRouteComponent);
}